// ===========================================
// STORAGE CONSTANTS
// ===========================================

/**
 * Local storage keys
 */
export const STORAGE_KEYS = {
  // Auth
  ACCESS_TOKEN: 'tt_access_token',
  REFRESH_TOKEN: 'tt_refresh_token',
  USER: 'tt_user',

  // Preferences
  LANGUAGE: 'tt_language',
  CURRENCY: 'tt_currency',
  THEME: 'tt_theme',

  // Session
  LAST_VISIT: 'tt_last_visit',
  SESSION_ID: 'tt_session_id',

  // Search
  RECENT_SEARCHES: 'tt_recent_searches',
  SEARCH_FILTERS: 'tt_search_filters',

  // Cart/Booking
  BOOKING_DRAFT: 'tt_booking_draft',
  CART_ITEMS: 'tt_cart_items',

  // UI State
  SIDEBAR_COLLAPSED: 'tt_sidebar_collapsed',
  COOKIE_CONSENT: 'tt_cookie_consent',
  NEWSLETTER_DISMISSED: 'tt_newsletter_dismissed',
} as const;

/**
 * Session storage keys
 */
export const SESSION_KEYS = {
  REDIRECT_URL: 'tt_redirect_url',
  FORM_DATA: 'tt_form_data',
  SCROLL_POSITION: 'tt_scroll_position',
} as const;

/**
 * Cookie names
 */
export const COOKIE_NAMES = {
  LANGUAGE: 'i18next',
  CONSENT: 'tt_cookie_consent',
  SESSION: 'tt_session',
  CSRF: 'tt_csrf',
} as const;

/**
 * Cookie expiration times (in days)
 */
export const COOKIE_EXPIRY = {
  SESSION: 1, // 1 day
  LANGUAGE: 365, // 1 year
  CONSENT: 365, // 1 year
  REMEMBER_ME: 30, // 30 days
} as const;
